
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useEnabledModules } from "@/hooks/useEnabledModules";
import DashboardMorador from "./dashboard/DashboardMorador";
import DashboardPorteiro from "./dashboard/DashboardPorteiro";
import DashboardSindico from "./dashboard/DashboardSindico";
import DashboardAdmin from "./dashboard/DashboardAdmin";
import DashboardMercado from "./dashboard/DashboardMercado";
import DashboardPontoEletronico from "./dashboard/DashboardPontoEletronico";
import DashboardAcessos from "./dashboard/DashboardAcessos";
import ErrorBoundary from "./ErrorBoundary";
import { Loader2 } from "lucide-react";

const Dashboard = () => {
  const { profile, loading } = useAuth();
  const { hasModule, loading: modulesLoading } = useEnabledModules();
  const [isContextReady, setIsContextReady] = useState(false);

  // Pequeno delay para garantir que todos os contextos estejam prontos
  useEffect(() => {
    if (!loading && profile) {
      const timer = setTimeout(() => {
        setIsContextReady(true);
      }, 100); // 100ms delay para garantir contextos
      
      return () => clearTimeout(timer);
    }
  }, [loading, profile]);

  // Mostrar loading enquanto o profile não está carregado OU contextos não estão prontos
  if (loading || modulesLoading || !profile || !isContextReady) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Carregando dashboard...</p>
        </div>
      </div>
    );
  }

  const renderDashboard = () => {
    // Platform administration is independent from a condominium license.
    if (profile.role === "superadmin") {
      return <Navigate to="/superadmin" replace />;
    }

    // Os módulos da organização decidem o dashboard; o tipo é só o preset de cadastro.
    if (!hasModule("full_itacondo")) {
      if (hasModule("access_control")) {
        if (profile.role === 'porteiro') {
          return <Navigate to="/acessos" replace />;
        }
        return <DashboardAcessos />;
      }

      if (hasModule("time_clock")) {
        return <DashboardPontoEletronico />;
      }
    }

    switch (profile.role) {
      case "morador":
        return <DashboardMorador />;
      case "porteiro":
        return <DashboardPorteiro />;
      case "sindico":
        return <DashboardSindico />;
      case "administracao":
        return <DashboardAdmin />;
      default:
        return <DashboardMorador />;
    }
  };

  return (
    <ErrorBoundary>
      <div className="p-6">
        {renderDashboard()}
      </div>
    </ErrorBoundary>
  );
};

export { Dashboard };
